import { useState } from "react";

import { useBuildInfo, useDownloadDebugData } from "./hooks";
import { ModalSheet } from "../components/ModalSheet";
import { useModal } from "../components/Modal";
import { Button, Checkbox } from "../ui";

// This will show the SHA and build date of the app, and download a text file containing:
// - User ID, email, username, and subscription tier.
// - User agent.
// - The Git SHA and build date of the app.
// - The current date and time.
// - The current URL.
// - Worker input data.
// - Worker caches.
// - The current local storage.
// - The current session storage.
// - The current IndexedDB data.
// - Memory usage info (if available).
// - All useQuery caches.
// - All useMutation caches.
export function useDiagnosticsModal() {
  const buildInfo = useBuildInfo();
  const { download } = useDownloadDebugData();
  const [compress, setCompress] = useState(true);

  const modal = useModal(() => {
    return (
      <ModalSheet
        title="Send Diagnostics Report"
        onClose={() => modal.close()}
        hideCloseButton={true}
        showHeaderCloseIcon={true}
        closeButtonVariant="secondary"
      >
        <div className="max-w-[380px] flex flex-col gap-4 overflow-y-auto max-h-[80vh]">
          <p className="text-foreground">
            Please only send a report if you have been asked to by a member of Customer Support.
          </p>
          <p className="text-foreground">
            By sending a diagnostics report, you are agreeing to share relevant data that is needed to debug your issue.
          </p>
          {buildInfo.data?.sha && (
            <div className="mb-2">
              <p className="text-foreground-muted">The git sha is {buildInfo?.data?.sha}</p>
              <p className="text-foreground-muted">This version of the app was built at {buildInfo?.data?.date}</p>
            </div>
          )}
        </div>
        <div className="pt-2 pb-3">
          <Checkbox
            checked={compress}
            onChange={(e) => setCompress(e.target.checked)}
            label="Compress report (recommended)"
          />
          <p className="text-foreground text-sm mt-1">
            * It might seem like the page is frozen while the report is being generated. If Chrome says the page is
            unresponsive, please choose the "Wait" option.
          </p>
        </div>
        <div className="flex justify-end mt-2 gap-4">
          <Button onClick={() => modal.close()} buttonType="cancel" className="font-medium">
            Cancel
          </Button>
          <Button
            onClick={() => {
              console.log("Downloading diagnostics report");
              download({}, compress);
            }}
            buttonType="save"
            className="px-6 font-medium"
          >
            Download Report
          </Button>
        </div>
      </ModalSheet>
    );
  });

  return modal;
}
